import { HiCheck } from "react-icons/hi";

const SIZES = {
  sm: { circle: "h-5 w-5 border-2", icon: "h-3 w-3" },
  md: { circle: "h-7 w-7 border-2", icon: "h-4 w-4" },
} as const;

interface CheckCircleProps {
  checked: boolean;
  size?: keyof typeof SIZES;
  className?: string;
}

/**
 * The app's tick: an empty circle says a thing can be picked, a filled one says it is. Inside a
 * `group`, hovering ghosts the check so the target reads as clickable before it is clicked.
 */
export function CheckCircle({ checked, size = "md", className = "" }: CheckCircleProps) {
  const { circle, icon } = SIZES[size];

  return (
    <span
      aria-hidden="true"
      className={`flex shrink-0 items-center justify-center rounded-full ${circle} ${
        checked
          ? "border-app-ink bg-app-ink text-white"
          : "border-gray-300 bg-white text-transparent group-hover:text-app-ink/25"
      } ${className}`}
    >
      <HiCheck className={icon} />
    </span>
  );
}
